/* SHAKEUP — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.nv-reveal, .nv-pasos__track, [data-nv-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('nv-visible'); if (el.dataset.nvCount) countUp(el, true); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('nv-visible');
        if (e.target.dataset.nvCount) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    // Seguro: nada puede quedarse oculto. Revela lo que ya está (o estuvo) en pantalla
    // aunque el observador no dispare (pestaña en segundo plano, navegadores antiguos, etc.).
    function revelarPasados() {
      var limite = window.innerHeight;
      els.forEach(function (el) {
        if (el.classList.contains('nv-visible')) return;
        if (el.getBoundingClientRect().top < limite) {
          el.classList.add('nv-visible');
          if (el.dataset.nvCount) countUp(el, true);
        }
      });
    }
    var tSeguro;
    window.addEventListener('scroll', function () { clearTimeout(tSeguro); tSeguro = setTimeout(revelarPasados, 400); }, { passive: true });
    window.addEventListener('load', function () { setTimeout(revelarPasados, 1200); });
    setTimeout(revelarPasados, 1800);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) revelarPasados(); });
    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el, instant) {
    var end = parseFloat(el.dataset.nvCount) || 0;
    var dur = parseInt(el.dataset.nvDur || '1800', 10);
    if (instant || end === 0) { el.textContent = end.toLocaleString('es'); return; }
    var t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = Math.round(end * eased).toLocaleString('es');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initParallax() {
    var items = document.querySelectorAll('[data-nv-parallax]');
    if (!items.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var k = parseFloat(el.dataset.nvParallax) || 0.15;
        var off = (r.top + r.height / 2 - vh / 2) * -k;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  function initTilt() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-nv-tilt]').forEach(function (card) {
      var max = parseFloat(card.dataset.nvTilt) || 8;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg) translateY(-6px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  function initMagnet() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-nv-stage]').forEach(function (stage) {
      var target = stage.querySelector('[data-nv-magnet]');
      if (!target) return;
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        target.style.transform = 'translate3d(' + (x * 24) + 'px,' + (y * 18) + 'px,0) rotate(' + (x * 4) + 'deg)';
      });
      stage.addEventListener('mouseleave', function () { target.style.transform = ''; });
    });
  }

  function initHeader() {
    var head = document.querySelector('.nv-head');
    if (!head) return;
    var onScroll = function () { head.classList.toggle('nv-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var menu = document.querySelector('.nv-mnav');
    var opener = null;
    function setMenu(on) {
      if (!menu) return;
      menu.classList.toggle('nv-on', on);
      menu.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.style.overflow = on ? 'hidden' : '';
      document.querySelectorAll('[data-nv-menu]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      if (on) { var first = menu.querySelector('a'); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50); }
      else if (opener) { opener.focus({ preventScroll: true }); }
    }
    if (menu) menu.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-nv-menu]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!menu) return;
        if (!menu.classList.contains('nv-on')) opener = b;
        setMenu(!menu.classList.contains('nv-on'));
      });
    });
    if (menu) menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu && menu.classList.contains('nv-on')) setMenu(false);
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-nv-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-nv-main]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-nv-thumb]'));
      if (!main || !thumbs.length) return;
      var idx = 0;
      function show(i) {
        idx = (i + thumbs.length) % thumbs.length;
        var t = thumbs[idx];
        thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        main.classList.add('nv-cambiando');
        setTimeout(function () {
          main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || '';
          main.onload = function () { main.classList.remove('nv-cambiando'); };
          setTimeout(function () { main.classList.remove('nv-cambiando'); }, 400);
        }, 180);
        t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = g.querySelector('[data-nv-prev]'), next = g.querySelector('[data-nv-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
        sx = null;
      });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-nv-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-nv-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var fmt = root.dataset.moneyFormat || '${{amount_no_decimals}}';
      var idInput = root.querySelector('product-form input[name="id"]');
      var btn = root.querySelector('[data-nv-add]');
      var btnTxt = btn && btn.querySelector('span');
      var priceEl = root.querySelector('[data-nv-price]');
      var compareEl = root.querySelector('[data-nv-compare]');
      var stickyPrice = document.querySelector('[data-nv-sticky-price]');
      root.querySelectorAll('[data-nv-option]').forEach(function (input) {
        input.addEventListener('change', function () {
          var sel = [];
          root.querySelectorAll('[data-nv-optgroup]').forEach(function (grp) {
            var c = grp.querySelector('input:checked'); sel.push(c ? c.value : null);
          });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) { if (btn) { btn.disabled = true; btnTxt.textContent = root.dataset.txtUnavailable; } return; }
          if (idInput) idInput.value = v.id;
          var p = money(v.price, fmt);
          if (priceEl) priceEl.textContent = p;
          if (stickyPrice) stickyPrice.textContent = p;
          if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : ''; }
          if (btn) { btn.disabled = !v.available; btnTxt.textContent = v.available ? root.dataset.txtAdd : root.dataset.txtSoldout; }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function money(cents, fmt) {
    var n = cents / 100;
    var noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var dec = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('no_decimals') > -1) return noDec;
      if (k.indexOf('comma') > -1) return dec;
      return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }

  function initQty() {
    document.querySelectorAll('[data-nv-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, v + parseInt(b.dataset.step, 10));
        });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-nv-sticky]');
    var add = document.querySelector('[data-nv-add]');
    // Si el botón de carrito está oculto (solo pago contra entrega), la barra se guía por la zona de compra.
    var anchor = add && add.offsetParent === null ? add.closest('.nv-prod__buy') : add;
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.nv-foot');
    var anchorVisible = true, footVisible = false;
    function sync() { bar.classList.toggle('nv-on', !anchorVisible && !footVisible && anchor.getBoundingClientRect().top < 0); }
    new IntersectionObserver(function (e) { anchorVisible = e[0].isIntersecting; sync(); }).observe(anchor);
    if (footer) new IntersectionObserver(function (e) { footVisible = e[0].isIntersecting; sync(); }).observe(footer);
    var b = bar.querySelector('button');
    if (b) b.addEventListener('click', function () {
      // Con el formulario de pago contra entrega, la barra abre ese formulario en vez de agregar al carrito.
      var cod = document.querySelector('.nv-prod__buy ._rsi-buy-now-button');
      (cod || add).click();
    });
  }

  function initSplit() {
    if (reduce) return;
    document.querySelectorAll('[data-nv-split]').forEach(function (el) {
      el.querySelectorAll('span').forEach(function (line, i) {
        line.style.setProperty('--d', i);
        line.classList.add('nv-line');
      });
    });
  }

  function initCarousel() {
    document.querySelectorAll('[data-nv-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-nv-car-track]');
      if (!track || track.dataset.nvReady) return;
      track.dataset.nvReady = '1';
      function step(dir) {
        var card = track.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 24 : track.clientWidth;
        var max = track.scrollWidth - track.clientWidth - 2;
        if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: max, behavior: 'smooth' }); return; }
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var p = root.querySelector('[data-nv-car-prev]'), n = root.querySelector('[data-nv-car-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  }

  function initCountdown() {
    var els = document.querySelectorAll('[data-nv-countdown]');
    if (!els.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    // Al terminar la oferta, los packs que dependen de ella desaparecen y la cantidad vuelve a 1.
    function finOferta() {
      document.querySelectorAll('[data-nv-solo-oferta]').forEach(function (box) {
        if (box.hidden) return;
        box.hidden = true;
        var root = box.closest('[data-nv-product]') || document;
        var qty = root.querySelector('[data-nv-qty] input');
        if (qty) { qty.value = 1; qty.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
    function tick() {
      els.forEach(function (el) {
        var fin = Date.parse(el.dataset.nvCountdown);
        var diff = Math.floor((fin - Date.now()) / 1000);
        if (isNaN(fin) || diff <= 0) { el.classList.add('nv-fin'); finOferta(); return; }
        var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60), s = diff % 60;
        var set = function (u, v) { var b = el.querySelector('[data-u="' + u + '"]'); if (b) b.textContent = v; };
        set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
      });
    }
    tick();
    if (!window.__suCountdown) window.__suCountdown = setInterval(tick, 1000);
  }

  function initEntrega() {
    document.querySelectorAll('[data-nv-entrega]').forEach(function (el) {
      var out = el.querySelector('[data-nv-entrega-fecha]');
      if (!out) return;
      function addBiz(n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      }
      var f = { weekday: 'short', day: 'numeric', month: 'short' };
      try {
        out.textContent = addBiz(parseInt(el.dataset.min, 10)).toLocaleDateString('es-CL', f) + ' y el ' + addBiz(parseInt(el.dataset.max, 10)).toLocaleDateString('es-CL', f);
      } catch (e) {}
    });
    document.querySelectorAll('[data-nv-linea]').forEach(function (el) {
      function addBiz(n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      }
      var f = { day: 'numeric', month: 'short' };
      try {
        el.querySelectorAll('[data-d]').forEach(function (s) {
          var v = s.dataset.d;
          if (v === '0') s.textContent = new Date().toLocaleDateString('es-CL', f);
          else if (v === '1') s.textContent = addBiz(1).toLocaleDateString('es-CL', f);
          else s.textContent = addBiz(parseInt(el.dataset.min, 10)).toLocaleDateString('es-CL', f) + ' – ' + addBiz(parseInt(el.dataset.max, 10)).toLocaleDateString('es-CL', f);
        });
      } catch (e) {}
    });
  }

  function initBuyNow() {
    document.querySelectorAll('[data-nv-buynow]').forEach(function (btn) {
      if (btn.dataset.nvReady) return; btn.dataset.nvReady = '1';
      btn.addEventListener('click', function () {
        var form = btn.closest('form');
        if (!form) return;
        var id = form.querySelector('[name="id"]').value;
        var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
        btn.classList.add('loading'); btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
          .catch(function () { btn.classList.remove('loading'); btn.disabled = false; window.location.href = '/cart'; });
      });
    });
  }

  function initPacks() {
    document.querySelectorAll('[data-nv-packs]').forEach(function (box) {
      if (box.dataset.nvReady) return; box.dataset.nvReady = '1';
      var root = box.closest('[data-nv-product]') || document;
      var qty = root.querySelector('[data-nv-qty] input');
      var radios = Array.prototype.slice.call(box.querySelectorAll('[data-nv-pack]'));
      function marcar(r) { radios.forEach(function (x) { x.closest('.nv-pack').classList.toggle('is-on', x === r); }); }
      radios.forEach(function (r) {
        r.addEventListener('change', function () { if (qty) qty.value = r.value; marcar(r); });
      });
      if (qty) {
        var sync = function () { var r = radios.find(function (x) { return x.value === String(parseInt(qty.value, 10)); }); radios.forEach(function (x) { x.checked = x === r; }); marcar(r || null); };
        qty.addEventListener('change', sync); qty.addEventListener('input', sync);
        var q = qty.closest('[data-nv-qty]'); if (q) q.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { setTimeout(sync, 0); }); });
      }
    });
  }

  function init() {
    initSplit(); initReveal(); initParallax(); initTilt(); initMagnet();
    initHeader(); initGallery(); initCarousel(); initCountdown(); initEntrega(); initBuyNow(); initPacks(); initVariants(); initQty(); initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
